import apiCaller from "../../../helper/apiCall";
import { DBT_MILK_PROCUREMENT_ENDPOINTS } from "../../urls/endpoints";

/**
 * Fetch farmer records for a specific DCS
 * @param {Object} params - Request parameters
 * @param {number} params.dcs_id - DCS ID
 * @param {string} params.date - Date (YYYY-MM-DD)
 * @param {string} params.shift - Shift filter (ALL, MORNING, EVENING)
 * @param {string} params.milk_type - Milk type filter (ALL, COW, BUFFALO)
 * @param {string} params.status_tab - Status tab (PENDING, APPROVED, REJECTED)
 * @param {string} params.search - Search query
 * @param {number} params.pageNo - Page number
 * @param {number} params.itemsPerPage - Items per page
 * @param {string} params.programCode - Program code
 */
const fetchFarmerRecords = async (params) => {
  const dataToSend = {
    dcs_id: params.dcs_id,
    date: params.date || new Date().toISOString().split("T")[0],
    shift: params.shift || "ALL",
    milk_type: params.milk_type || "ALL",
    status_tab: params.status_tab || "PENDING",
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 20,
    programCode: params.programCode,
    exportFlag: params.exportFlag || false,
  };

  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.FARMER_RECORDS,
    "POST",
    dataToSend
  );
  return response;
};

const sendApprovalOtp = async (params) => {
  const dataToSend = {
    purpose: params.purpose || "DBT_APPROVAL",
    phone: params.phone,
  };
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.DBT_SEND_OTP,
    "POST",
    dataToSend
  );
  return response;
}

/**
 * 
 * @param {*} params 
 * @returns 
 */

const dcsApproveFarmer = async (params) => {
  const dataToSend = {
    record_ids: params.record_ids,
    otp: params.otp,

  }
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.DCS_APPROVE_FARMER,
    "POST",
    dataToSend
  );
  return response;
}

/**
 * 
 * @param {*} params 
 * @returns 
 */

const dcsRejectFarmer = async (params) => {
  const dataToSend = {
    date: params.date,
    reject_records: params.reject_records,
    comment: params.comment,
  }
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.DCS_REJECT_FARMER,
    "POST",
    dataToSend
  );
  return response;
}

/**
 * 
 * @param {*} params 
 * @returns 
 */

const ApproverApproveFarmer = async (params) => {
  const dataToSend = {
    date: params.date,
    record_ids: params.record_ids,
    otp: params.otp,

  }
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.UNION_APPROVE_FARMER,
    "POST",
    dataToSend
  );
  return response;
}

/**
 * Bulk approve DCS entries by the Approver (using dcs_ids + otp)
 */
const ApproverApproveDcs = async (params) => {
  const dataToSend = {
    date: params.date,
    dcs_ids: params.dcs_ids,
    otp: params.otp,
  }
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.UNION_APPROVE_FARMER,
    "POST",
    dataToSend
  );
  return response;
}
const ApproverRejectFarmer = async (params) => {
  const dataToSend = {
    reject_records: params.reject_records,
    comment: params.comment,
  }
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.UNION_REJECT_FARMER,
    "POST",
    dataToSend
  );
  return response;
}

/**
 * Fetch DCS summary list
 * @param {Object} params - Request parameters
 * @param {string} params.date - Date (YYYY-MM-DD)
 * @param {number} params.approverId - Approver ID
 * @param {string} params.search - Search query
 * @param {number} params.pageNo - Page number
 * @param {number} params.itemsPerPage - Items per page
 * @param {Object} params.sort - Sort configuration
 */
const fetchDcsSummary = async (params) => {
  const dataToSend = {
    date: params.date || new Date().toISOString().split("T")[0],
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 10,
    sort: params.sort || { attributes: ["dcsName"], sorts: ["asc"] },
    exportFlag: params.exportFlag || false,
  };

  // Non-admin: send approverId or checkerId
  if (params.approverId) {
    dataToSend.approverId = params.approverId;
  }
  if (params.checkerId) {
    dataToSend.checkerId = params.checkerId;
  }
  // Admin: send union_id and/or dcs_id
  if (params.union_id) {
    dataToSend.union_id = params.union_id;
  }
  if (params.dcs_id) {
    dataToSend.dcs_id = params.dcs_id;
  }
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.DCS_SUMMARY,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch DCS list that haven't poured milk since their last poured date
 * @param {Object} params - Request parameters
 * @param {string} params.date - Date (YYYY-MM-DD)
 * @param {string|number} params.unionId - Union ID (admin)
 * @param {string|number} params.dcsId - DCS ID (admin)
 * @param {string|number} params.approverId - Approver ID (non-admin)
 * @param {string} params.search - Search query
 * @param {number} params.pageNo - Page number
 * @param {number} params.itemsPerPage - Items per page
 * @param {Object} params.sort - Sort configuration
 * @param {boolean} params.exportFlag - Export flag
 */
const fetchDcsNotPoured = async (params) => {
  const dataToSend = {
    date: params.date || new Date().toISOString().split("T")[0],
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 200,
    sort: params.sort || { attributes: ["lastPouredDate"], sorts: ["asc"] },
    exportFlag: params.exportFlag || false,
  };
  if (params.unionId) dataToSend.unionId = params.unionId;
  if (params.dcsId) dataToSend.dcsId = params.dcsId;
  if (params.approverId) dataToSend.approverId = params.approverId;
  if (params.checkerId) dataToSend.checkerId = params.checkerId;
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.DCS_NOT_POURED,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch rejection reasons for milk procurement
 */
const fetchRejectionReasons = async () => {
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.REJECTION_REASONS,
    "GET"
  );
  return response;
};

const exportFarmerRecords = async (params) => {
  const dataToSend = {
    programCode: params.programCode || "MILKPROCUREMENT",
    currentPage: params.currentPage || 0,
    search: params.search || "",
    searchCol: params.searchCol || "",
    sortCol: params.sortCol || "",
    type: params.type || "ASC",
    // filters: params.filters || {},
    // tabType: params.tabType || "",
    cards: false,
    exportFlag: true,
  };
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.EXPORT_FARMER_RECORDS,
    "POST",
    dataToSend
  );
  return response;
}

/**
 * Fetch deduction table records for a specific DCS
 * @param {Object} params
 * @param {number} params.dcs_id
 * @param {string} params.date - YYYY-MM-DD
 * @param {string} params.search
 * @param {number} params.pageNo
 * @param {number} params.itemsPerPage
 * @param {boolean} [params.exportFlag]
 */
const fetchDeductionTable = async (params) => {
  const dataToSend = {
    dcs_id: params.dcs_id,
    date: params.date || new Date().toISOString().split("T")[0],
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 20,
    sort: params.sort || { attributes: ["posting_date"], sorts: ["desc"] },
    exportFlag: params.exportFlag || false,
  };
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.DEDUCTION_TABLE,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch DCS-wise deduction list (admin / union / approver)
 * @param {Object} params
 * @param {number|string} [params.union_id]   - Admin / Union: union filter
 * @param {number|string} [params.approverId] - Approver: approver filter
 * @param {string} params.date - YYYY-MM-DD
 * @param {string} params.search
 * @param {number} params.pageNo
 * @param {number} params.itemsPerPage
 * @param {boolean} params.exportFlag
 * @param {Object} params.sort
 */
const fetchDeductionDcsWise = async (params) => {
  const dataToSend = {
    date: params.date || new Date().toISOString().split("T")[0],
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 20,
    exportFlag: params.exportFlag || false,
    sort: params.sort || { attributes: ["totalDeductionAmount"], sorts: ["desc"] },
  };
  if (params.union_id) dataToSend.union_id = params.union_id;
  if (params.approverId) dataToSend.approverId = params.approverId;
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.DEDUCTION_DCS_WISE,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch payout DCS list
 * @param {Object} params
 * @param {string} params.fromDate
 * @param {string} params.toDate
 * @param {string} params.search
 * @param {number} params.pageNo
 * @param {number} params.itemsPerPage
 * @param {Object} params.sort
 */
const fetchPayoutDcsList = async (params) => {
  const dataToSend = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 10,
    sort: params.sort || { attributes: ["dcs_name"], sorts: ["asc"] },
    exportFlag: params.exportFlag || false,
    programCode: params.programCode,
  };
  if (params.unionId) dataToSend.unionId = params.unionId;
  if (params.dcsId) dataToSend.dcsId = params.dcsId;
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.PAYOUT_PENDING_DCS,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch payout farmer list
 * @param {Object} params
 * @param {number} params.dcsId
 * @param {string} params.fromDate
 * @param {string} params.toDate
 * @param {string} params.search
 * @param {number} params.pageNo
 * @param {number} params.itemsPerPage
 * @param {Object} params.sort
 */
const fetchPayoutFarmerList = async (params) => {
  const dataToSend = {
    dcsId: params.dcsId,
    fromDate: params.fromDate,
    toDate: params.toDate,
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 20,
    sort: params.sort || { attributes: ["member_name"], sorts: ["asc"] },
    exportFlag: params.exportFlag || false,
    programCode: params.programCode,
  };
  if (params.unionId) dataToSend.unionId = params.unionId;
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.PAYOUT_PENDING_FARMERS,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch paid payout DCS list
 * @param {Object} params
 */
const fetchPaidDcsList = async (params) => {
  const dataToSend = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 10,
    sort: params.sort || { attributes: ["paid_at"], sorts: ["desc"] },
    programCode: params.programCode,
  };
  if (params.unionId) dataToSend.unionId = params.unionId;
  if (params.dcsId) dataToSend.dcsId = params.dcsId;
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.PAID_DCS_LIST,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch paid payout farmer list
 * @param {Object} params
 */
const fetchPaidFarmers = async (params) => {
  const dataToSend = {
    dcsId: params.dcsId,
    fromDate: params.fromDate,
    toDate: params.toDate,
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 20,
    sort: params.sort || { attributes: ["member_name"], sorts: ["asc"] },
    programCode: params.programCode,
  };
  if (params.unionId) dataToSend.unionId = params.unionId;
  if (params.approverId) dataToSend.approverId = params.approverId;
  if (params.checkerId) dataToSend.checkerId = params.checkerId;
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.PAID_FARMERS,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Approves payout for a DCS or specific farmers.
 * @param {Object} params - { dcsId, fromDate, toDate, farmerIds: [], remarks: "" }
 */
const approvePayout = async (params) => {
  const dataToSend = {
    dcsId: params.dcsId,
    fromDate: params.fromDate,
    toDate: params.toDate,
    farmerIds: params.farmerIds || [],
    remarks: params.remarks || "",
    programCode: params.programCode,
  };
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.APPROVE_PAYOUT,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch payment cycles for a specific union, approver or checker
 * @param {Object} params - { unionId, limit, approverId, checkerId }
 */
const fetchPaymentCycles = async (params) => {
  const dataToSend = {
    limit: params.limit || 24,
  };
  if (params.unionId) {
    dataToSend.unionId = params.unionId;
  }
  if (params.approverId) {
    dataToSend.approverId = params.approverId;
  }
  if (params.checkerId) {
    dataToSend.checkerId = params.checkerId;
  }
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.PAYMENT_CYCLE_DROPDOWN,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch payment cycle table (all unions with cycle config)
 * @param {Object} params - { search, pageNo, itemsPerPage }
 */
const fetchPaymentCycleTable = async (params) => {
  const dataToSend = {
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 10,
  };
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.PAYMENT_CYCLE_TABLE,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Create a new payment cycle for a union (first-time configuration)
 * @param {Object} params - { unionId, cycleDays, anchorDate, status, reason }
 */
const createPaymentCycle = async (params) => {
  const dataToSend = {
    unionId: params.unionId,
    cycleDays: params.cycleDays,
    anchorDate: params.anchorDate,
    status: params.status || "Active",
    reason: params.reason || "",
  };
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.PAYMENT_CYCLE_UPDATE,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Update an existing payment cycle for a union
 * @param {Object} params - { unionId, cycleDays, anchorDate, status, reason }
 */
const updatePaymentCycle = async (params) => {
  const dataToSend = {
    unionId: params.unionId,
    cycleDays: params.cycleDays,
    anchorDate: params.anchorDate,
    status: params.status || "Active",
    reason: params.reason || "",
  };
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.PAYMENT_CYCLE_UPDATE,
    "PUT",
    dataToSend
  );
  return response;
};

/**
 * Fetch payment cycle history for a union
 * @param {Object} params - { unionId, pageNo, itemsPerPage }
 */
const fetchPaymentCycleHistory = async (params) => {
  const dataToSend = {
    unionId: params.unionId,
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 20,
  };
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.PAYMENT_CYCLE_HISTORY,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch final payment sheet (paid farmers export)
 * @param {Object} params
 * @param {number} params.dcsId - DCS ID
 * @param {string} params.fromDate
 * @param {string} params.toDate
 * @param {number} params.unionId
 * @param {string} params.search
 * @param {number} params.pageNo
 * @param {number} params.itemsPerPage
 * @param {Object} params.sort
 */
const fetchFinalPaymentSheet = async (params) => {
  const dataToSend = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 20,
    sort: params.sort || { attributes: ["member_name"], sorts: ["asc"] },
  };
  if (params.dcsId) dataToSend.dcsId = params.dcsId;
  if (params.unionId) dataToSend.unionId = params.unionId;
  if (params.approverId) dataToSend.approverId = params.approverId;
  if (params.checkerId) dataToSend.checkerId = params.checkerId;
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.FINAL_PAYMENT_SHEET,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Export final payment sheet — returns a URL to download the Excel file
 * @param {Object} params - { fromDate, toDate, dcsId, unionId, approverId, checkerId, search }
 */
const exportFinalPaymentSheet = async (params) => {
  const dataToSend = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    search: params.search || "",
    programCode: params.programCode,
  };
  if (params.dcsId) dataToSend.dcsId = params.dcsId;
  if (params.unionId) dataToSend.unionId = params.unionId;
  if (params.approverId) dataToSend.approverId = params.approverId;
  if (params.checkerId) dataToSend.checkerId = params.checkerId;
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.FINAL_PAYMENT_SHEET,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch payment status list (successful / failed payments)
 * @param {Object} params
 * @param {string} params.tab - "successful" or "failed"
 * @param {string} params.fromDate
 * @param {string} params.toDate
 * @param {number} params.unionId
 * @param {number} params.approverId
 * @param {string} params.search
 * @param {number} params.pageNo
 * @param {number} params.itemsPerPage
 */
const fetchPaymentStatusList = async (params) => {
  const dataToSend = {
    tab: params.tab || "successful",
    fromDate: params.fromDate,
    toDate: params.toDate,
    search: params.search || "",
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 20,
    programCode: params.programCode,
    exportFlag: params.exportFlag || false,
  };
  if (params.unionId) dataToSend.unionId = params.unionId;
  if (params.approverId) dataToSend.approverId = params.approverId;
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.PAYMENT_STATUS,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Upload payment sheet
 * @param {FormData} formData
 */
const uploadPaymentSheet = async (formData) => {
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.UPLOAD_PAYMENT,
    "POST",
    formData,
    { "Content-Type": "multipart/form-data" }
  );
  return response;
};

/**
 * Fetch milk reconciliation summary
 * @param {Object} params
 * @param {string} params.dumpDate - Date in YYYY-MM-DD format
 * @param {number} params.pageNo - 1-based page number
 * @param {number} params.itemsPerPage - Items per page
 * @param {string} params.search - Free-text search
 */
const fetchMilkReconciliationSummary = async (params) => {
  const dataToSend = {
    dumpDate: params.dumpDate,
    pageNo: params.pageNo || 1,
    itemsPerPage: params.itemsPerPage || 20,
    search: params.search || "",
    exportFlag: params.exportFlag || false,
  };
  // optional filters
  if (params.unionId) dataToSend.unionId = params.unionId;
  if (params.dcsId) dataToSend.dcsId = params.dcsId;
  if (params.shift) dataToSend.shift = params.shift;
  if (params.dcsNo) dataToSend.dcsNo = params.dcsNo;
  if (params.icccBmcCode) dataToSend.icccBmcCode = params.icccBmcCode;
  if (params.milkType) dataToSend.milkType = params.milkType;
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.MILK_RECONCILIATION_TABLE,
    "POST",
    dataToSend
  );
  return response;
};

/**
 * Fetch milk reconciliation record detail view
 * @param {Object} params
 * @param {number} params.reconciliationId - Record ID
 */
const fetchMilkReconciliationView = async (params) => {
  const dataToSend = {
    reconciliationId: params.reconciliationId,
  };
  const response = await apiCaller(
    DBT_MILK_PROCUREMENT_ENDPOINTS.MILK_RECONCILIATION_VIEW,
    "POST",
    dataToSend
  );
  return response;
};

export {
  fetchFarmerRecords,
  fetchDcsSummary,
  fetchDcsNotPoured,
  fetchRejectionReasons,
  sendApprovalOtp,
  dcsApproveFarmer,
  dcsRejectFarmer,
  ApproverApproveFarmer,
  ApproverApproveDcs,
  ApproverRejectFarmer,
  exportFarmerRecords,
  fetchDeductionTable,
  fetchDeductionDcsWise,
  fetchPayoutDcsList,
  fetchPayoutFarmerList,
  fetchPaidDcsList,
  fetchPaidFarmers,
  approvePayout,
  fetchPaymentCycles,
  fetchPaymentCycleTable,
  createPaymentCycle,
  updatePaymentCycle,
  fetchPaymentCycleHistory,
  fetchFinalPaymentSheet,
  exportFinalPaymentSheet,
  fetchPaymentStatusList,
  uploadPaymentSheet,
  fetchMilkReconciliationSummary,
};
